import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, MessageCircle, User, Users } from 'lucide-react';
import { motion } from 'framer-motion';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: Home, label: 'Home', path: '/', testId: 'nav-home' },
    { icon: BookOpen, label: 'Resources', path: '/resources', testId: 'nav-resources' },
    { icon: Users, label: 'Voices', path: '/real-voices', testId: 'nav-voices' },
    { icon: MessageCircle, label: 'Forum', path: '/forum', testId: 'nav-forum' },
    { icon: User, label: 'Profile', path: '/profile', testId: 'nav-profile' },
  ];

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 z-50 md:bottom-4 md:left-1/2 md:right-auto md:transform md:-translate-x-1/2 md:w-auto"
    >
      <div className="bg-white/95 md:bg-white/90 backdrop-blur-xl border-t-4 md:border-4 border-ssdp-navy md:rounded-full px-2 py-2 md:px-4 md:py-2.5 shadow-[0_4px_0px_0px_rgba(30,58,89,1)] md:shadow-[6px_6px_0px_0px_rgba(30,58,89,1)]">
        <div className="flex items-center justify-around md:gap-1 max-w-md mx-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
              (item.path !== '/' && location.pathname.startsWith(item.path));
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`relative flex flex-col md:flex-row items-center gap-0.5 md:gap-2 px-3 md:px-4 py-2 rounded-xl md:rounded-full transition-all ${
                  isActive
                    ? 'text-ssdp-navy bg-ssdp-teal/10'
                    : 'text-ssdp-navy/50 hover:text-ssdp-navy/80 hover:bg-ssdp-purple/5'
                }`}
                data-testid={item.testId}
              >
                <Icon className="w-5 h-5 md:w-5 md:h-5" strokeWidth={isActive ? 2.5 : 2} />
                <span className={`text-[10px] md:text-xs font-bold ${isActive ? 'font-black' : ''}`}>
                  {item.label}
                </span>
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-ssdp-teal rounded-full md:hidden"
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default BottomNav;
